import NewspaperCategoryCard from './NewspaperCategoryCard';

import './styles/NewspaperCategorySlider.css';

/**
 * Horizontal scrollable list of newspaper categories without navigation arrows.
 */
export default function NewspaperCategorySlider({ categories = [] }) {
  return (
    <nav className="newspaper-category-slider__container" aria-label="Newspaper categories">
      <div className="newspaper-category-slider__categories remove-scrollbar">
        {categories.map((item) => (
          <NewspaperCategoryCard
            key={
              item._id ||
              item.id ||
              item.collection_id ||
              item.collection_name
            }
            title={item.name}
            link={item.collection_id ? `/newspaper/${item.collection_id}` : undefined}
          />
        ))}
      </div>
    </nav>
  );
}
